import React, {useEffect, useState} from "react"
import { Button, Heading } from "components"
import CustomCheckbox from "components/CheckBox"
import { useTranslation } from "react-i18next"

export default function MainContactForm() {
    const { t } = useTranslation()
    const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

    const [form, setForm] = useState({
        name: '',
        phone: '',
        question: '',
    })
    const [agreed, setAgreed] = useState(true)

    // валидатор на клиенте
    const phonePattern = /^(\+7|8)[\s\-]?\(?\d{3}\)?[\s\-]?\d{3}[\s\-]?\d{2}[\s\-]?\d{2}$/

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target
        setForm(f => ({ ...f, [name]: value }))
    }

    const Notification = ({
                              type,
                              onClose
                          }: {
        type: 'success' | 'error',
        onClose: () => void
    }) => {
        const content = {
            success: {
                icon: "/images/notificationSuccess.svg",
                title: "Успех",
                text: "Заявка успешно отправлена, с вами свяжутся в ближайшее время.",
                bg: "bg-[#4AC99B]",
                closeIcon: '/images/close-white.svg',
                closeClass: 'text-white'
            },
            error: {
                icon: "/images/notificationError.svg",
                title: "Ошибка",
                text: "Попробуйте отправить заявку позже.",
                bg: "bg-[#FDEAE4]",
                closeIcon: '/images/close-black.svg',
                closeClass: 'text-[#212121]'
            }
        };

        return (
            <div
                className={`absolute top-16 right-[390px] md:top-6 md:right-12 sm:top-12 sm:right-10 z-50 w-[320px] sm:w-[295px] sm:h-[112px] h-[92px] p-3 rounded-[12px]  ${content[type].bg} flex items-start gap-3 animate-slide-in`}>
                {/* Иконка */}
                <img
                    src={content[type].icon}
                    alt="status"
                    className="w-4 h-4 mt-1"
                />

                {/* Текстовый блок */}
                <div className="flex-1">
                    <h3 className={`font-extrabold text-[15px] leading-6 mb-1  ${type === 'success' ? 'text-[#FFFFFF]' : 'text-[#191C30E5]'}`}>
                        {content[type].title}
                    </h3>
                    <p className={`text-[13px] leading-5 ${type === 'success' ? 'text-[#FFFFFF]' : 'text-[#191C30E5]'}`}>
                        {content[type].text}
                    </p>
                </div>

                {/* Кнопка закрытия */}
                <button
                    onClick={onClose}
                    className="text-[#616161] hover:text-[#212121] transition-colors"
                >
                    <img
                        src={content[type].closeIcon}
                        className={`w-2.5 h-2.5 mt-1 mr-1 ${content[type].closeClass}`}
                        alt="close"
                    />
                </button>
            </div>
        );
    };

    const handleCloseNotification = () => {
        setSubmitStatus('idle');
    };

    useEffect(() => {
        if (submitStatus === 'success' || submitStatus === 'error') {
            const timer = setTimeout(() => {
                setSubmitStatus('idle')
            }, 10000)
            return () => clearTimeout(timer)
        }
    }, [submitStatus])

    const isValid =
        form.name.trim() !== '' &&
        phonePattern.test(form.phone) &&
        form.question.trim() !== '' &&
        agreed

    async function handleSubmit(e: React.FormEvent) {
        e.preventDefault()
        if (!isValid) return
        const res = await fetch('https://api.hyperionix.ru/api/v1/landing/request', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                name: form.name,
                phone: form.phone,
                your_question: form.question,
            }),
        })
        if (res.status !== 200) {
            setSubmitStatus('error')
        } else {
            setSubmitStatus('success')
        }
    }

    return (
        <>
            <section id="ContactForm"
                     className={'relative container-xs'}>
                <div className="flex justify-center p-6 md:p-0 sm:px-[16px]">
                    <div className="container-xs max-w-screen-md w-full flex justify-center md:px-5">
                        <div className="flex flex-row md:flex-col sm:flex-col w-full items-start rounded-[99999px] md:rounded-[64px] sm:rounded-[32px] bg-[#333333] px-20 sm:px-6 py-[206.5px] md:py-10 sm:py-10 md:px-6 gap-8">

                            <Heading
                                size="desktop_heading_2"
                                className="sm:hidden font-medium text-[#FFFFFF] lg:mr-[111px] md:mb-6 md:mt-[56px]"
                            >
                                {t("contactForm.title")}
                            </Heading>
                            <Heading
                                size="desktop_heading_4"
                                className="font-medium text-[#FFFFFF] md:hidden lg:hidden sm:uppercase"
                            >
                                {t("contactForm.title")}
                            </Heading>

                            <div className="flex lg:flex-1 flex-col items-end gap-10 self-center w-full">
                                <form
                                    className="flex flex-col items-end gap-4 w-full"
                                    onSubmit={handleSubmit}
                                >
                                    <input
                                        name="name"
                                        type="text"
                                        required
                                        value={form.name}
                                        onChange={handleChange}
                                        placeholder={t("contactForm.filed.name")}
                                        className="w-[606px] md:max-w-full md:w-full sm:w-full rounded-[12px] px-4 h-[56px] bg-[#FFFFFF29] shadow-[0px_2px_3px_0px_#0000001A] placeholder:text-[#FFFFFFB8] focus:outline-none focus:border-none focus:ring-0"
                                    />

                                    <input
                                        name="phone"
                                        type="tel"
                                        required
                                        value={form.phone}
                                        onChange={handleChange}
                                        pattern="^(\+7|8)[\s\-]?\(?\d{3}\)?[\s\-]?\d{3}[\s\-]?\d{2}[\s\-]?\d{2}$"
                                        inputMode="tel"
                                        onKeyPress={e => {
                                            // блокируем буквы
                                            if (!/[0-9()+\-\s]/.test(e.key)) {
                                                e.preventDefault()
                                            }
                                        }}
                                        placeholder={t("contactForm.filed.phone")}
                                        className="w-[606px] md:max-w-full md:w-full sm:w-full rounded-[12px] px-4 h-[56px] bg-[#FFFFFF29] shadow-[0px_2px_3px_0px_#0000001A] placeholder:text-[#FFFFFFB8] focus:outline-none focus:border-none focus:ring-0"
                                    />

                                    <textarea
                                        name="question"
                                        required
                                        value={form.question}
                                        onChange={handleChange}
                                        placeholder={t("contactForm.filed.question")}
                                        className="w-[606px] md:max-w-full md:w-full sm:w-full rounded-[12px] px-4 py-3 h-[112px] bg-[#FFFFFF29] shadow-[0px_2px_3px_0px_#0000001A] placeholder:text-[#FFFFFFB8] resize-none"
                                    />

                                    <div className="flex flex-col items-start pt-6 sm:pt-[14px] w-full md:mb-[56px]">
                                        {submitStatus === 'success' && (
                                            <Notification
                                                type="success"
                                                onClose={handleCloseNotification}
                                            />
                                        )}
                                        {submitStatus === 'error' && (
                                            <Notification
                                                type="error"
                                                onClose={handleCloseNotification}
                                            />
                                        )}
                                        <Button
                                            onClick={() => handleSubmit}
                                            type="submit"
                                            shape="round"
                                            disabled={!isValid}
                                            className={`h-[56px] w-[320px] bg-[#FFB800] hover:bg-[#FFC224] disabled:opacity-50 disabled:cursor-not-allowed sm:w-full sm:h-[44px]`}
                                        >
                                            <Heading
                                                size="desktop_body_m_bold"
                                                className="font-extrabold text-[#1B1F3B]"
                                            >
                                                {t("contactForm.button")}
                                            </Heading>
                                        </Button>
                                        <div className="pt-4">
                                            <CustomCheckbox
                                                checked={agreed}
                                                onChange={e => setAgreed(e.target.checked)}
                                            />
                                        </div>
                                    </div>
                                </form>
                            </div>

                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
